(function() {
	'use strict';

	angular
		.module('humbertContainer')
		.filter('ContainerTypesByFraction', ContainerTypesByFraction);

	ContainerTypesByFraction.$inject = [];

	function ContainerTypesByFraction() {
		return ContainerTypesByFractionFilter;

		////////////////

		function ContainerTypesByFractionFilter(containerTypes,fraction) {
			var match = {};

			if (angular.isUndefined(fraction)) {
				return false;
			}

			angular.forEach(containerTypes, function(containerType, containerTypeKey) {
				if (fraction.containerTypes.hasOwnProperty(containerTypeKey)) {
					match[containerTypeKey] = containerType;
				}
			});

			return match;
		}
	}

})();